module.exports = __webpack_public_path__ + "img/expand.d830f0d3.svg";